<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item :label="$t('areaList.name')" class="mb-0">
							<el-input size="small" v-model="from.name" ></el-input>
						</el-form-item>
						
						<el-form-item :label="$t('layout.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>


                        <el-form-item :label="$t('areaList.areaType')" class="mb-0">
							<el-select v-model="from.type" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('areaList.oneArea')" :value="1"></el-option>
								<el-option :label="$t('areaList.twoArea')" :value="2"></el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('areaList.add')}}</el-button>
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				
				<el-table-column align="center"  prop="name" :label="$t('areaList.name')">
				</el-table-column>
                <el-table-column align="center" prop="name_lang" :label="$t('areaList.nameLang')">
				</el-table-column>
                <el-table-column align="center" prop="up_name" :label="$t('areaList.upArea')">
				</el-table-column>
                <el-table-column align="center" prop="type" :label="$t('areaList.areaType')">
                    <template slot-scope="scope">
						<span v-if="scope.row.type == 1" class="text_chengse">{{$t('areaList.oneArea') }}</span>
						<span v-if="scope.row.type == 2" >{{ $t('areaList.twoArea') }}</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="create_time" :label="$t('layout.createTime')">
				</el-table-column>
				<el-table-column prop="id" align="center" :label="$t('layout.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary" v-auth="'edit'+auth_val" @click="openModel(scope)">{{$t('layout.operation')}}</el-button>
							<el-button @click="deleteItem(scope.row)" v-auth="'del'+auth_val" size="mini" plain type="danger">{{$t('layout.delete')}}</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>


        
		<el-footer
		class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		:style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		>
			<div style="flex: 1;" class="px-2">
				<el-pagination
				:current-page="page.current"
				:page-sizes="page.sizes"
				:page-size="page.size"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				background
                :layout="layout.isMobile ? 'total, prev, pager, next' : 'total, prev, pager, next, sizes, jumper'"
				:total="page.total"
				/>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('areaList.edit') : $t('areaList.add')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			@close="hide"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				
				<el-form-item :label="$t('areaList.name')" prop="name">
					<el-input v-model="form.name"  clearable size="small" :placeholder="$t('areaList.name')"  style="width: 85%;"></el-input>
				</el-form-item>
                <el-form-item :label="$t('areaList.nameLang')" prop="name_lang">
					<el-input v-model="form.name_lang"  :placeholder="$t('areaList.nameLang')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>
                <el-form-item :label="$t('areaList.areaType')">
					<el-radio-group v-model="form.type" size="small">
						<el-radio :label="1" border>{{$t('areaList.oneArea')}}</el-radio>
						<el-radio :label="2" border>{{$t('areaList.twoArea')}}</el-radio>
					</el-radio-group>
				</el-form-item>
                <el-form-item v-if="form.type == 2" :label="$t('areaList.upArea')" prop="parent">
					<el-select v-model="form.parent" size="small" filterable :placeholder="$t('system.select')" style="width: 85%;">
						<el-option v-for="item in area_list" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
                
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="hide">{{$t('system.cancel')}}</el-button>
				<el-button type="primary" @click="submit" :loading="this.layout.loading">{{$t('system.confirm')}}</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {

				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
                    type:-1,
					time:[],
				},
				auth_val: 'Area',

                prop: 'id',
                sort: 'descending',

				preUrl: "data/areaList", //列表地址
				// delAllUrl: "user/delAdminAll", //批量删除地址
				delUrl: "data/delArea", //删除單条地址
				addUrl: "data/addArea", //添加/修改地址
				editStatusUrl:"data/editStatusArea",//修改狀態地址

				tableData: [],
				form: {
                    name: "",
                    name_lang: '',
					type: 1,
                    parent:''
				},
				rules: {
					name: [{
						required: true,
						message: this.$t('areaList.nameRequired'),
						trigger: 'blur',
					}],
					name_lang: [{
						required: true,
						message: this.$t('areaList.nameLangRequired'),
						trigger: 'blur',
					}],
                    parent: [{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.type === 2 && !value) {
								callback(new Error(this.$t('areaList.areaTypeRequired')));
							} else {
								callback();
							}
						},
						trigger: 'change'
					}],
					
				},
				area_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList(['area']);
		},
		methods: {
            validateParent(rule, value, callback) {
                if (this.form.id > 0) {
                    if (!value) {
                        return callback(new Error(this.$t('areaList.passwordLength'))); // 只有 type == 2 时才校验
                    }
                }
                callback(); // 其他情况不校验
            },
			//提交
			submit() {
				if (this.form.password != this.form.password2) {
					this.$message({
						message: this.$t('areaList.differentPasswords'),
						type: 'error'
					});
					return
				}
				this.$refs.form.validate(res => {
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			hide(){
                // 初始化表單
				this.form = {
						name: "",
						name_lang: '',
						type: 1,
						parent: '',
					}
					this.editIndex = -1
                    this.createModel = false
            },
			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						name: "",
						name_lang: '',
						type: 1,
						parent: '',
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						name: e.row.name,
						name_lang: e.row.name_lang,
						type:  e.row.type,
						parent:  e.row.parent,
					}
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.area_list = list.area

					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
                    type:-1,
					time:[],
				}
			
				this.search = ''
				this.getList()
			},
			
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}
</style>
